import { render, staticRenderFns } from "./dlg_upgrade_downgrade_plan.vue?vue&type=template&id=2c500915&scoped=true&"
import script from "./dlg_upgrade_downgrade_plan.vue?vue&type=script&lang=js&"
export * from "./dlg_upgrade_downgrade_plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c500915",
  null
  
)

export default component.exports